// @flow

import { CategoryBadge } from '@gandi/cart';

import { ActionBlock } from 'src/Reshaped/Modal/ActionBlock';
import type { ModalType } from 'src/Reshaped/hooks/useModalType';

import styles from './ContactSelect.scss';

type Props = {
  children?: React.Node,
  disabled?: boolean,
  title: string,
  type: ModalType,
};

export function ContactSelect({
  children,
  disabled,
  title,
  type,
}: Props): React.MixedElement {
  return (
    <ActionBlock
      position="relative"
      type={type}
      disabled={disabled}
      className={styles.root}
    >
      <CategoryBadge>{title}</CategoryBadge>
      {children}
    </ActionBlock>
  );
}
